import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    currentProfile: null,
    error: null,
    loading: false
};

const companyProfileSlice = createSlice({
    name: 'companyProfile',
    initialState,
    reducers: {
        setCurrentProfile: (state, action) => {
            state.currentProfile = action.payload;
        },
        clearCurrentProfile: (state) => {
            state.currentProfile = null;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        }
    }
});

export const {
    setCurrentProfile,
    clearCurrentProfile,
    setError,
    setLoading
} = companyProfileSlice.actions;

export default companyProfileSlice.reducer;